module.exports = __webpack_public_path__ + "img/05.100cfed6.png";